/*
Muestra del template default y modifica el custom

*/
import React, { useEffect, useState } from 'react'
import {
  BoldItalicUnderlineToggles,
  listsPlugin,
  ListsToggle,
  MDXEditor,
  MDXEditorMethods,
  toolbarPlugin,
} from '@mdxeditor/editor'
import { Remark } from 'react-remark'

import { useAuth } from '../hooks/useAuth'
import useTemplateFetcher from '../hooks/useTemplateFetcher'
import { TempFooter } from '../interfaces/TemplateDto'
import useTemplatePoster from '../hooks/useTemplatePoster'
import { AppPath } from '../enums/AppPath'
import { DEFAULT_TITLE_CONFIG, getDefaultDocumentTitle } from '../utils/documentTitleUtils'

import { RadioGroupEx, RadioItem } from './RadioGroup'
import { ButtonAction } from './Buttons'
import { Info } from './MessageInfo'
import TitleEditor from './TitleEditor'

const predetFooterCollection: RadioItem[] = [
  { label: 'Pie (Usar Prederminado)' },
  { label: 'Pie (Usar Personalizado)' },
]
const TemplateDoc: React.FC<{ setClickedIndex: React.Dispatch<React.SetStateAction<number>>; docType: AppPath }> = ({
  setClickedIndex,
  docType,
}) => {
  const refPie = React.useRef<MDXEditorMethods>(null)

  const { userData } = useAuth()

  const [pieIndex, setPieIndex] = useState<number>(0)
  const [infoMessage, setInfoMessage] = useState<string>('')
  const [titleData, setTitleData] = useState(DEFAULT_TITLE_CONFIG)
  const defaultTitle = getDefaultDocumentTitle(docType)

  const { postTemplateDocs, errorPostTemplate } = useTemplatePoster()
  const { errorTemplate, fetchTemplateDocFull } = useTemplateFetcher()
  const [footerFull, setFooterFull] = useState<{ default: TempFooter; custom: TempFooter } | null>(null)

  const organizationId = userData?.organization?._id
  const buttonDisabled = false
  useEffect(() => {
    const fetchDataAsync = async () => {
      if (!organizationId) return
      const data = await fetchTemplateDocFull(organizationId, docType)

      if (data) {
        setFooterFull(data)
        refPie.current?.setMarkdown(data.custom.footer.value ?? '')
        setPieIndex(data.custom.footer.type === '.' ? 1 : 0)

        // Set title data with fallback
        const customTitle = data.custom.title ?? { ...DEFAULT_TITLE_CONFIG }
        setTitleData(customTitle)
      }
    }
    fetchDataAsync()
  }, [organizationId, docType])

  const footerDefault = footerFull?.default.footer.value ?? ''

  const handleTitleChange = (newTitle: any) => {
    setTitleData(newTitle)
  }

  const handleStoreClick = async () => {
    const footMark = refPie.current?.getMarkdown()

    const template: TempFooter = {
      title: titleData,
      footer: {
        type: pieIndex === 0 ? '' : '.',
        value: footMark,
      },
    }

    console.log(`Saving ${docType} template:`, template)
    console.log('Title data being sent:', titleData)

    const res = await postTemplateDocs(template, docType)

    if (res) {
      console.log('Template saved successfully')
      setClickedIndex(-1)
    } else {
      console.error('Failed to save template')
    }
  }
  const handleCancelClick = async () => {
    setClickedIndex(-1)
  }

  return (
    <>
      <TitleEditor
        titleData={titleData}
        onTitleChange={handleTitleChange}
        defaultTitle={defaultTitle}
        documentType={
          docType === AppPath.Reservations ? 'reservation' : docType === AppPath.Estimates ? 'estimate' : 'salenote'
        }
      />

      <div className="border">
        <div className="grid grid-cols-2 gap-2 ml-2 mb-2">
          <RadioGroupEx
            collection={predetFooterCollection}
            name={'pie'}
            checked={pieIndex}
            callback={(idx) => setPieIndex(idx)}
            className="flex items-center space-x-2 mr-10 mb-1"
            labelClassName="font-bold"
          />
          <div className="border">
            <Remark>{footerDefault}</Remark>
          </div>
          <MDXEditor
            ref={refPie}
            markdown=""
            plugins={[
              listsPlugin(),
              toolbarPlugin({
                toolbarClassName: 'my-classname',
                toolbarContents: () => (
                  <>
                    <BoldItalicUnderlineToggles />
                    <ListsToggle />
                  </>
                ),
              }),
            ]}
          />
        </div>
      </div>

      <div className="flex justify-center mt-4">
        <ButtonAction label="Grabar" handleButtonClick={handleStoreClick} disabled={buttonDisabled} />
        <div className="ml-4">
          <ButtonAction label="Cerrar" handleButtonClick={handleCancelClick} />
        </div>
      </div>
      <div className="flex justify-center mt-4">
        <Info message={infoMessage} trigger={Date.now()} onTimeout={() => setInfoMessage('')} noCenter={true} />
      </div>
      <div>{errorTemplate?.message}</div>
      <div>{errorPostTemplate?.message}</div>
    </>
  )
}
export default TemplateDoc
